import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import { T } from "../constants";
import { cx } from "../styles";

/* ---------- Phone number field, with country select ---------- */

const usePhoneField = makeStyles({
  wrap: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    width: "100%",
    boxSizing: "border-box",
    borderRadius: 6,
    border: `1px solid ${T.border}`,
    background: T.elevated,
    padding: "8px 12px",
    fontSize: 14,
    color: T.fg,
    fontFamily: "inherit",
    "&:focus-within": {
      borderColor: T.primary,
      boxShadow: `0 0 0 2px ${T.primaryTint}`,
    },
    "& .PhoneInputInput": {
      flex: 1,
      minWidth: 0,
      border: "none",
      outline: "none",
      background: "transparent",
      fontSize: 14,
      color: T.fg,
      fontFamily: "inherit",
      "&::placeholder": { color: T.subtleFg },
    },
    "& .PhoneInputCountrySelect": { color: T.fg, fontFamily: "inherit" },
    "& .PhoneInputCountrySelectArrow": { color: T.mutedFg, opacity: 1 },
  },
  /* Only shown once the operator has typed something unusable — an empty field
   * is "not filled in yet", not an error. */
  invalid: { borderColor: T.danger },
});

/*
 * `value` is E.164 ("+61412345678") — the shape the backend stores — or "" when
 * the field is empty. The country select only decides how the digits typed are
 * interpreted; it never travels separately.
 */
export default function PhoneField({
  value,
  onChange,
  defaultCountry,
  placeholder,
  invalid = false,
  className,
}) {
  const c = usePhoneField();

  return (
    <PhoneInput
      international
      countryCallingCodeEditable={false}
      defaultCountry={defaultCountry}
      value={value || undefined}
      onChange={(next) => onChange(next ?? "")}
      placeholder={placeholder}
      className={cx(c.wrap, invalid && c.invalid, className)}
    />
  );
}
